;(() => {
  //in Nosto placements, we can only get the product badge handle from the product metafield
  //we need to detect when product badges are added, and then loop through them and replace them with the relevant text from the product_badges_json_object
  const productBadgesSelector = '.nosto_element .product-badges'
  const productBadgesObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.matches(productBadgesSelector)
        ) {
          handleAddBadges(node)
        }
        //also check child nodes
        node
          .querySelectorAll?.(productBadgesSelector)
          .forEach((child) => handleAddBadges(child))
      })
    })
  })

  function handleAddBadges(element) {
    Array.from(element.children).forEach((badge) => {
      const handle = badge.textContent
      if (handle !== 'SALE') {
        badge.textContent = window.limely.product_badges[handle]?.text || handle
      }
    })
  }

  productBadgesObserver.observe(document.body, {
    childList: true,
    subtree: true
  })
})()
